import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, MenuItem } from 'react-pro-sidebar';
import { motion } from 'framer-motion';

const SETTINGS_MENU_ITEMS = [
    { name: 'Online Payments', url: '/settings/payment-gateway' },
];

export const SettingsSidebarHeader = ({ collapsed = false }) => {
    if (collapsed) {
        return (
            <div className="mb-2 flex justify-center rounded border border-[#0A426C] p-2" title="Settings">
                <img src="/images/settings_active.svg" alt="icon" />
            </div>
        );
    }

    return (
        <div className="mb-2 flex items-center border-b border-[#0A426C] px-1 py-1.5">
            <span className="pl-2 text-[20px] font-medium text-white">Settings</span>
        </div>
    );
};

const SettingsSidebar = ({ collapsed = false }) => {
    const location = useLocation();
    const isRouteActive = (url) => location.pathname.startsWith(url);

    if (collapsed) {
        return (
            <motion.ul
                key="settings-menu-collapsed"
                initial={{ x: 20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 20, opacity: 0 }}
                transition={{ duration: 0.25, ease: 'easeInOut' }}
            >
                {SETTINGS_MENU_ITEMS.map((item) => (
                    <li className="mb-2.5" key={item.url}>
                        <Link
                            title={item.name}
                            to={item.url}
                            className={`flex items-center px-2.5 py-4 hover:bg-[#052136] hover:delay-75 ${
                                isRouteActive(item.url) ? ' bg-[#052136]' : ''
                            }`}
                        >
                            <img
                                loading="lazy"
                                decoding="async"
                                src="/images/settings_active.svg"
                                alt="icon"
                                className="mx-auto"
                            />
                        </Link>
                    </li>
                ))}
            </motion.ul>
        );
    }

    return (
        <motion.div
            key="settings-menu"
            initial={{ x: 40, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 40, opacity: 0 }}
            transition={{ duration: 0.25, ease: 'easeInOut' }}
        >
            <ul>
                <Menu
                    iconShape="square"
                    menuItemStyles={{
                        button: ({ active }) => ({
                            color: '#EEF7FE',
                            backgroundColor: active ? '#0973c1' : 'transparent',
                            '&:hover': {
                                backgroundColor: active ? '#0973c1' : '#052136',
                                color: '#EEF7FE',
                            },
                        }),
                    }}
                >
                    {SETTINGS_MENU_ITEMS.map((item) => (
                        <Link to={item.url} key={item.url}>
                            <MenuItem
                                active={isRouteActive(item.url)}
                                className="transition duration-150 ease-in-out hover:bg-[#052136]"
                                id="no-child"
                                style={{ color: '#95C0E0' }}
                            >
                                {item.name}
                            </MenuItem>
                        </Link>
                    ))}
                </Menu>
            </ul>
        </motion.div>
    );
};

export default SettingsSidebar;
